import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/requisition/manage.php`,
  API_SEARCH: `/ERP/requisition/search.php`,
};

/* ใบเบิกวัตถุดิบ จาก Production Order */
const RequisitionService = () => {
  const get = (rqcode) => api.get(`${API_URL.API_MANAGE}?code=${encodeURIComponent(rqcode)}`);
  /* ยอดตามสูตร Master Process ของ PD (kg) */
  const prefill = (pdcode) =>
    api.get(`${API_URL.API_MANAGE}?prefill=${encodeURIComponent(pdcode)}`);
  /* lot ที่ยังเหลือของวัตถุดิบ เรียงหมดอายุก่อน */
  const lots = (stcode) =>
    api.get(`${API_URL.API_MANAGE}?lots=${encodeURIComponent(stcode)}`, { ignoreLoading: true });
  /* วัตถุดิบที่มีของในคลัง สำหรับเพิ่มรายการเอง */
  const materials = (q = "", all = false) =>
    api.get(`${API_URL.API_MANAGE}?materials=1${all ? "&all=1" : ""}&q=${encodeURIComponent(q)}`, { ignoreLoading: true });

  const create = (parm = {}) => api.post(API_URL.API_MANAGE, { ...parm, action: "create" });
  const update = (parm = {}) => api.put(API_URL.API_MANAGE, parm);
  const confirm = (parm = {}) => api.post(API_URL.API_MANAGE, { ...parm, action: "confirm" });
  const cancel = (rqcode) => api.post(API_URL.API_MANAGE, { rqcode, action: "cancel" });

  const search = (parm = {}, config = {}) =>
    api.post(API_URL.API_SEARCH, parm, { ...config, cancle: true });

  return { get, prefill, lots, materials, create, update, confirm, cancel, search };
};

export default RequisitionService;
